import React from 'react';
import { X, Info } from 'lucide-react';

const normalizeChargeLabel = (charge) => {
  const raw = charge.charge_name || charge.label || charge.name || charge.type
    || charge.charge_type || charge.description || charge.head || charge.title || '';
  return String(raw)
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .trim();
};

const normalizeChargeAmount = (charge) => {
  const val = charge.charge_amount ?? charge.amount ?? charge.value
    ?? charge.inr_amount ?? charge.total ?? 0;
  return parseFloat(val) || 0;
};

const PriceBreakdownModal = ({ isOpen, onClose, courier }) => {
  if (!isOpen || !courier) return null;

  const charges = courier.detailedCharges;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 relative max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X size={24} />
        </button>

        <div className="mb-6">
          <h2 className="text-lg font-bold text-[#1a2b4b]">Price Details</h2>
          <p className="text-xs text-gray-500 mt-1">The prices shown here include applicable taxes and surcharges</p>
        </div>

        {charges && Array.isArray(charges) && charges.length > 0 ? (
          <>
            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-gray-50 border-b border-gray-200">
                    <th className="text-left px-4 py-2.5 text-xs font-semibold text-gray-600 uppercase tracking-wider">
                      Particulars
                    </th>
                    <th className="text-right px-4 py-2.5 text-xs font-semibold text-gray-600 uppercase tracking-wider">
                      Charges
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {charges.filter(ch => normalizeChargeAmount(ch) > 0).map((charge, idx) => {
                    const label = normalizeChargeLabel(charge) || `Charge ${idx + 1}`;
                    const amount = normalizeChargeAmount(charge);
                    return (
                      <tr key={idx} className="hover:bg-gray-50">
                        <td className="px-4 py-2.5 text-gray-700">{label}</td>
                        <td className="px-4 py-2.5 text-right font-medium text-gray-900">
                          ₹{amount.toFixed(2)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="mt-4 flex justify-between items-center px-4 py-3 bg-blue-50 rounded-lg border border-blue-100">
              <span className="font-semibold text-gray-800">Total</span>
              <span className="font-bold text-lg text-blue-600">
                ₹{Number(courier.totalCharges || 0).toFixed(2)}
              </span>
            </div>
          </>
        ) : (
          <div className="flex flex-col items-center justify-center py-8 text-gray-500">
            <Info size={32} className="mb-3 text-gray-300" />
            <p className="text-sm font-medium">No detailed charge breakup available.</p>
            <p className="text-xs text-gray-400 mt-1">The courier did not return itemized charges for this rate.</p>
          </div>
        )}

        <div className="mt-6">
          <button
            onClick={onClose}
            className="w-full px-4 py-3 bg-[#1a2b4b] text-white rounded-xl font-bold hover:bg-[#253a63] transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PriceBreakdownModal;
